import { Component, Input, OnInit } from '@angular/core';
import { Parcel } from 'src/app/model/parcel.model';
import { RefDeliveryinformation } from 'src/app/model/refDeliveryinformation.model';
import { AtInternetService } from 'src/app/services/at-internet.service';
import { DeliveryChoiceService } from 'src/app/services/delivery-choice.service';

@Component({
  selector: 'app-delivery-bloc',
  templateUrl: './delivery-bloc.component.html',
  styleUrls: ['./delivery-bloc.component.scss']
})
export class DeliveryBlocComponent implements OnInit {

  @Input() trackingParcel: Parcel;
  @Input() tag;
  refDeliveryinformation: RefDeliveryinformation;
  openingHour: boolean = false;
  count = 0;
  hideReceiverPersonalInfo: boolean = false;

  constructor(
    private deliveryChoiceService: DeliveryChoiceService,
    private atInternetService: AtInternetService) { }

  ngOnInit(): void {
    if (this.trackingParcel.removalPoint) {
      this.deliveryChoiceService.getDeliveryInformations(this.trackingParcel.removalPoint.siteCode).subscribe(
        response => {
          this.refDeliveryinformation = response;
          // pour verifier si this.refDeliveryinformation contient qqchose afin d'afficher ou non le chevron pour le bloc des horaires
          if (this.refDeliveryinformation != null && this.refDeliveryinformation != undefined && this.refDeliveryinformation) {
            this.count = Object.keys(this.refDeliveryinformation).length;
          }
        });
    } else {
      /***
       * PRG025 : rule to show the receiver's adresse or not
       * https://wiki.net.extra.laposte.fr/confluence/pages/viewpage.action?pageId=692717801
       */
      if (this.trackingParcel.step) {
        this.trackingParcel.step.forEach(element => {
          if (element.stepId === 5 && element.status === 'STEP_STATUS_INACTIVE') {
            if (this.trackingParcel.event) {
              let dateOfLastEvent = this.trackingParcel.event[0].date;
              let eventCode = this.trackingParcel.event[0].code;
              this.trackingParcel.event.forEach(el => {
                if (el.date > dateOfLastEvent) {
                  dateOfLastEvent = el.date;
                  eventCode = el.code;
                }
              })
              if (!['DESLIVD', 'DESLIEUD', 'DESOBS'].includes(eventCode)) {
                if (this.trackingParcel.geographicCoverage === 'NAT') {
                  // national parcel
                  if ((Date.now() > (new Date(dateOfLastEvent).getTime() + 5 * 24 * 60 * 60 * 1000))) {
                    this.hideReceiverPersonalInfo = true;
                  }
                } else {
                  // international parcel
                  if ((Date.now() > (new Date(dateOfLastEvent).getTime() + 10 * 24 * 60 * 60 * 1000))) {
                    this.hideReceiverPersonalInfo = true;
                  }
                }
              }
            }
          }
        })
      }
    }

  }

  showOpeningHours(): void {
    this.openingHour = !this.openingHour;
  }
  generateTagIfOpen() {
    if (this.openingHour) {
      this.atInternetService.generateClickAction(
        this.tag,
        'chevron_horaires_pdr',
        'chevron_ouvert'
      );
    }
  }
}